(function() {
    'use strict';

    angular
        .module('functional7App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gimnasio', {
            parent: 'entity',
            url: '/gimnasio',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'functional7App.gimnasio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gimnasio/gimnasios.html',
                    controller: 'GimnasioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gimnasio');
                    $translatePartialLoader.addPart('estado');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gimnasio-detail', {
            parent: 'gimnasio',
            url: '/gimnasio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'functional7App.gimnasio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gimnasio/gimnasio-detail.html',
                    controller: 'GimnasioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gimnasio');
                    $translatePartialLoader.addPart('estado');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Gimnasio', function($stateParams, Gimnasio) {
                    return Gimnasio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gimnasio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gimnasio-detail.edit', {
            parent: 'gimnasio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gimnasio/gimnasio-dialog.html',
                    controller: 'GimnasioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gimnasio', function(Gimnasio) {
                            return Gimnasio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gimnasio.new', {
            parent: 'gimnasio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gimnasio/gimnasio-dialog.html',
                    controller: 'GimnasioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                direccion: null,
                                fechaAlta: null,
                                correoElectronico: null,
                                personaContacto: null,
                                idiomaContacto: null,
                                telefono: null,
                                estado: null,
                                needChangePass: null,
                                lastUpdate: null,
                                logedId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gimnasio', null, { reload: 'gimnasio' });
                }, function() {
                    $state.go('gimnasio');
                });
            }]
        })
        .state('gimnasio.edit', {
            parent: 'gimnasio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gimnasio/gimnasio-dialog.html',
                    controller: 'GimnasioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gimnasio', function(Gimnasio) {
                            return Gimnasio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gimnasio', null, { reload: 'gimnasio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gimnasio.delete', {
            parent: 'gimnasio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gimnasio/gimnasio-delete-dialog.html',
                    controller: 'GimnasioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Gimnasio', function(Gimnasio) {
                            return Gimnasio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gimnasio', null, { reload: 'gimnasio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
